












import { Vue, Prop, Component } from 'vue-property-decorator';
import ProductCount from '@/components/Molecules/Input/ProductCount.vue';

@Component({
  components: {
    ProductCount,
  },
})
export default class PlanInputArea extends Vue {
  @Prop() payload!: { [key: string]: string };
  @Prop() private namespace!: string;
  @Prop() planTotal!: number;
  @Prop() index!: number;

  updateCount(count: number) {
    this.$emit('updateCount', { index: this.index, count: count });
  }
}
